import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private firstNavigationComplete = false;

  private completed = new Subject<void>();

  constructor(private router: Router) {}

  init() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: any) => {
      if (event.id === 1 && (event as NavigationStart).navigationTrigger === 'imperative') {
        // This is the first navigation
      } else {
        // Subsequent navigations
        this.firstNavigationComplete = true;
        this.completed.next();
        this.completed.complete();
      }
    });
  }

  isFirstLoad(): boolean {
    return !this.firstNavigationComplete;
  }
}
